module.exports = __webpack_public_path__ + "static/media/Report-bro.88b99af2.png";